// extracted by mini-css-extract-plugin
module.exports = {"whyZemogaSection":"d_j","description":"d_k","section":"d_l","headerGrid":"d_m"};